import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `<div>Columns Control</div>`;
const settingsControlTemplate = ``;

export class ColumnsControl extends DesignControl {
  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.Columns;
  }

  public edit(): void {}

  public cancel(): void {}

  public save(): void {}

  public copy(): void {}
}
